import axios, { AxiosResponse } from 'axios';
import { con } from '../../../application/entity/Rutas';
import { IServiceResult } from '../../Interfaces/IServiceResult';
import { ServiceResult } from './ServiceResult';

export class SVCParametros {

    public static async ObtieneTransferencia(
        rutAlumno: number,
        idProcesoItemPago: number,
        numTransaccion: string,
        rutTitular: number,
        dvTitular: string,
        nombreTitular: string,
        idBanco: number,
        idTipoCuenta: number,
        correoTitular: string,
        montoPagado: number,
        guidHQB: string,
        idEstado: number,
        usuario: string
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "TransferenciasBancarias/getTransferenciasBancarias";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        var f = new Date()
        var d = f.getFullYear() + '-' + ((f.getMonth() + 1).toString().length === 1 ? ('0' + (f.getMonth() + 1)) : (f.getMonth() + 1)) + '-' + (f.getDate().toString().length === 1 ? ('0' + f.getDate()) : f.getDate())
        await axios
            .post(url,
                {
                    "rutAlumno": rutAlumno,
                    "idTransferencia": 0,
                    "idProcesoItemPago": idProcesoItemPago,
                    "numTransaccion": numTransaccion,
                    "rutTitular": rutTitular,
                    "dvTitular": dvTitular,
                    "nombreTitular": nombreTitular,
                    "idBanco": idBanco,
                    "idTipoCuenta": idTipoCuenta,
                    "correoTitular": correoTitular,
                    "montoPagado": montoPagado,
                    "rutaHQB": "",
                    "guidHQB": guidHQB,
                    "fechaTransaccion": d,
                    "fechaEstado": d,
                    "idEstado": idEstado,
                    "usuario": usuario,
                    "observacion": ""
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneTransferenciaListado(
        codigoNegocio: number,
        rutAlumno: number,
        codSede: number,
        codCarrera: string,
        ano: number,
        periodo: number,
        idEstado: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "TransferenciasBancarias/getTransferenciasBancarias";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        //var f = new Date()
        //var d = f.getFullYear() + '-' + ((f.getMonth() + 1).toString().length === 1 ? ('0' + (f.getMonth() + 1)) : (f.getMonth() + 1)) + '-' + (f.getDate().toString().length === 1 ? ('0' + f.getDate()) : f.getDate())
        await axios
            .post(url,
                {
                    "codigoNegocio": codigoNegocio,
                    "rutAlumno": rutAlumno,
                    "codSede": codSede,
                    "codCarrera": codCarrera,
                    "ano": ano,
                    "periodo": periodo,
                    "idEstado": idEstado
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async InsertTransferencia(
        headers: any,
        rutAlumno: number,
        idProcesoItemPago: number,
        numTransaccion: string,
        rutTitular: number,
        dvTitular: string,
        nombreTitular: string,
        idBanco: number,
        idTipoCuenta: number,
        correoTitular: string,
        montoPagado: number,
        guidHQB: string,
        idEstado: number,
        usuario: string,
        idComprobante: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + "PostTransferenciaBancariaPorIdItemPago";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        var f = new Date()
        var d = f.getFullYear() + '-' + ((f.getMonth() + 1).toString().length === 1 ? ('0' + (f.getMonth() + 1)) : (f.getMonth() + 1)) + '-' + (f.getDate().toString().length === 1 ? ('0' + f.getDate()) : f.getDate())
        await axios
            .post(url,
                {
                    "rutAlumno": rutAlumno,
                    "idTransferencia": idComprobante ?? 0,
                    "idProcesoItemPago": idProcesoItemPago,
                    "numTransaccion": numTransaccion,
                    "rutTitular": rutTitular,
                    "dvTitular": dvTitular,
                    "nombreTitular": nombreTitular,
                    "idBanco": idBanco,
                    "idTipoCuenta": idTipoCuenta,
                    "correoTitular": correoTitular,
                    "montoPagado": montoPagado,
                    "rutaHQB": "",
                    "guidHQB": guidHQB,
                    "fechaTransaccion": d,
                    "fechaEstado": d,
                    "idEstado": idEstado,
                    "usuario": usuario,
                    "observacion": ""
                }, { headers })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneTieneTransferencia(
        idProceso: number,
        codigoItem: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "TransferenciasBancarias/getTieneTransferencia";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        var data: any = []
        await axios
            .post(url, data, {
                params: {
                    "idProceso": idProceso,
                    "codigoItem": codigoItem
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async UpdateTransferencia(
        idTransferencia: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "TransferenciasBancarias/updateEstadoTransferencia";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        var data: any = []
        await axios
            .post(url, data, {
                params: {
                    "idTransferencia": idTransferencia
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async DeleteTransferencia(
        idItemPago: number
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "TransferenciasBancarias/DeleteTransferenciaPorId";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        var data: any = []
        await axios
            .post(url, data, {
                params: {
                    "idTransferencia": idItemPago
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
}